import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Join from "@/pages/Join";
import Dashboard from "@/pages/Dashboard";
import Users from "@/pages/Users";
import Companies from "@/pages/Companies";
import Requests from "@/pages/Requests";
import Audit from "@/pages/Audit";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import PhotoMigration from "@/pages/PhotoMigration";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import EmailChangeSuccess from "@/pages/EmailChangeSuccess";
import BrowseCategories from "@/pages/BrowseCategories";
import SystemLineItems from "@/pages/SystemLineItems";
import SystemMarkupTiers from "@/pages/SystemMarkupTiers";
import SystemLineItemForm from "@/pages/SystemLineItemForm";
import PlatformSuppliers from "@/pages/PlatformSuppliers";
import PlatformSettings from "@/pages/PlatformSettings";
import AdminLayout from "@/components/layout/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

const queryClient = new QueryClient();

const App = () => (
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/join" element={<Join />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/email-change-success" element={<EmailChangeSuccess />} />

        <Route
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/requests" element={<Requests />} />
          <Route path="/audit" element={<Audit />} />
          <Route path="/settings" element={<PlatformSettings />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/photo-migration" element={<PhotoMigration />} />
          <Route path="/catalog/categories" element={<BrowseCategories />} />
          <Route path="/catalog/system-items" element={<SystemLineItems />} />
          <Route path="/catalog/system-items/new" element={<SystemLineItemForm />} />
          <Route path="/catalog/system-items/:id/edit" element={<SystemLineItemForm />} />
          <Route path="/catalog/markup-tiers" element={<SystemMarkupTiers />} />
          <Route path="/catalog/suppliers" element={<PlatformSuppliers />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </QueryClientProvider>
  </BrowserRouter>
);

export default App;
